<div class="comment" [ngClass]="{ 'comment--reply-mode': isReplay() }">
  <div class="comment__info">
    <!-- comment profile -->
    <div class="comment-user">
      <!-- user image -->
      <img
        class="comment-user__img"
        [ngSrc]="
          comment()?.user?.profile_image?.cropped_thumbnail ||
            comment()?.user?.profile_image?.cropped_url
            | imageSource: false : 'sm' : 'assets/images/no-profile-image.png'
        "
        width="64"
        height="64"
        alt="" />
      <div class="comment-user__content">
        <!-- user name -->
        <h4 class="username">
          {{ comment()?.user?.first_name }} {{ comment()?.user?.last_name }}
        </h4>
        <!-- user job position -->
        <p class="user-role">
          {{ comment()?.user?.job_position | translateData }}
        </p>
      </div>
    </div>
    <!-- comment date -->
    <div class="comment-date">
      <!-- comment date text -->
      <p class="comment-date__text">{{ comment()?.created_at }}</p>
      <!-- comment new answer -->
      <button class="comment-date__replay" (click)="onReplay()">
        {{ 'global.replay' | translate }}
      </button>
    </div>
  </div>
  <div class="comment__content">
    <!-- comment text -->
    <p class="comment-text">
      {{ comment()?.text | translateData }}
    </p>
  </div>
</div>
